import script from "./AiChatbotDevelopmentServicesSwitzerland.vue?vue&type=script&setup=true&lang=js"
export * from "./AiChatbotDevelopmentServicesSwitzerland.vue?vue&type=script&setup=true&lang=js"

import "./AiChatbotDevelopmentServicesSwitzerland.vue?vue&type=style&index=0&id=253335f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-253335f8"]])

export default __exports__